import { Injectable, OnInit } from '@angular/core'
import { environment } from '../../environments/environment'
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService implements OnInit{
  env = environment;
  userTypes = UserTypes;
  taskGroups = TaskGroups;
  countriesUrl = 'app/_shared/_data/countries.json'
  constructor(private http: HttpClient) { 
    
  }

  ngOnInit(): void {

  }

  private handleError(err: HttpErrorResponse) {
    if (err.status === 401) {
      return throwError(err.statusText);
    }

    let errorMsg = (err.error.message != '' && err.error.message != undefined && err.error.message != null) ? err.error.message : 'An unexpected error occured';
    console.error(errorMsg);
    return throwError(errorMsg);
  }
}


export const UserTypes = {
  internalUser: 0,
  partnerUser: 1
};

export const TaskGroups = {
  quotesSpecialist: 1,
  fulfillmentSupport: 2
};

